<rk-sidenav-action-wrapper
  [title]="'PLAYLIST.CREATE_FORM.TITLE' | translate"
  (submitted)="submit()"
  (cancelled)="exitPanel()"
  [disabledSubmit]="
    !createPlaylistForm || !createPlaylistForm.get('name').valid || (isSaving$ | async)
  "
>
  <form
    *ngIf="createPlaylistForm"
    (ngSubmit)="submit()"
    [formGroup]="createPlaylistForm"
    novalidate
  >
    <div class="form-fields">
      <div>
        <rk-form-field
          [label]="'PLAYLIST.CREATE_FORM.NAME' | translate"
          [hideCharLimit]="true"
        >
          <input
            data-cy="create-playlist-name"
            type="text"
            rkInput
            formControlName="name"
            maxlength="150"
            required
          />
          <rk-form-error
            *ngIf="createPlaylistFormErrors.name.required"
            [errorMessage]="'PLAYLIST.CREATE_FORM.TITLE_REQUIRED' | translate"
          ></rk-form-error>
        </rk-form-field>
        <rk-form-field [label]="'PLAYLIST.CREATE_FORM.COLOR' | translate">
          <rk-input-color-picker
            [showWhite]="false"
            formControlName="color"
          ></rk-input-color-picker>
        </rk-form-field>
      </div>
    </div>

    <div class="playlist-type">
      <div class="section-title" translate>PLAYLIST.CREATE_FORM.SETTINGS</div>
      <rk-form-field>
        <mat-radio-group rkInput formControlName="type">
          <mat-radio-button data-cy="radio-button-manual-playlist" value="manual">{{
            'PLAYLIST.CREATE_FORM.PLAYLIST_MANUAL' | translate
          }}</mat-radio-button>
          <span class="hint" translate>PLAYLIST.CREATE_FORM.HINT_MANUAL</span>
          <mat-radio-button data-cy="radio-button-dynamic-playlist" value="dynamic">{{
            'PLAYLIST.CREATE_FORM.PLAYLIST_AUTO' | translate
          }}</mat-radio-button>
          <span class="hint" translate>PLAYLIST.CREATE_FORM.HINT_AUTO</span>
        </mat-radio-group>
      </rk-form-field>
      <div *ngIf="createPlaylistForm.get('type').value === 'dynamic'">
        <div class="criteria-title" translate>PLAYLIST.CREATE_FORM.CRITERIA_TITLE</div>
        <div class="criteria-hint" translate>PLAYLIST.CREATE_FORM.CRITERIA_HINT</div>
        <div *ngIf="getCriteriaLength()" formArrayName="criteria">
          <div
            *ngFor="let criterion of criteria.controls; let i = index"
            class="criteria"
          >
            <div [ngSwitch]="getCriteriaType(criterion.value.field)">
              <rk-playlist-criteria-text
                *ngSwitchCase="'text'"
                [title]="getCriteriaTitle(criterion.value.field)"
                [formControlName]="i"
                [data]="getCriteriaTextSuggestion(criterion.value.field)"
                (deleteCriteria)="removeCriteria($event)"
                [submitEvent$]="submitSubject.asObservable()"
              ></rk-playlist-criteria-text>
              <rk-playlist-criteria-number
                *ngSwitchCase="'number'"
                [title]="getCriteriaTitle(criterion.value.field)"
                [formControlName]="i"
                (deleteCriteria)="removeCriteria($event)"
                [submitEvent$]="submitSubject.asObservable()"
              ></rk-playlist-criteria-number>
              <rk-playlist-criteria-box
                *ngSwitchCase="'box'"
                [title]="getCriteriaTitle(criterion.value.field)"
                [formControlName]="i"
                (deleteCriteria)="removeCriteria($event)"
                [submitEvent$]="submitSubject.asObservable()"
              ></rk-playlist-criteria-box>
              <rk-playlist-criteria-tag
                *ngSwitchCase="'tags'"
                [title]="getCriteriaTitle(criterion.value.field)"
                [formControlName]="i"
                (deleteCriteria)="removeCriteria($event)"
                [submitEvent$]="submitSubject.asObservable()"
              ></rk-playlist-criteria-tag>
              <rk-playlist-criteria-date
                *ngSwitchCase="'date'"
                [title]="getCriteriaTitle(criterion.value.field)"
                [formControlName]="i"
                (deleteCriteria)="removeCriteria($event)"
                [submitEvent$]="submitSubject.asObservable()"
              ></rk-playlist-criteria-date>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="createPlaylistForm.get('type').value === 'dynamic'">
        <rk-button
          [label]="'PLAYLIST.CREATE_FORM.ADD_CRITERIA' | translate"
          [matMenuTriggerFor]="criteriaMenu"
          btnStyle="flat"
          class="add-criteria-button"
        ></rk-button>
        <ng-container *ngIf="!getCriteriaLength()">
          <img src="/assets/playlist-no-criteria.svg" alt="" />
        </ng-container>
      </ng-container>
    </div>
  </form>
  <mat-menu #criteriaMenu="matMenu" class="criteria-mat-menu">
    <div mat-menu-item (click)="addCriteria('idtrackbox')">
      <mat-icon fontSet="fa" fontIcon="fa-inbox"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.BOX</span>
    </div>
    <div mat-menu-item (click)="addCriteria('artist')">
      <mat-icon fontSet="fa" fontIcon="fa-user"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.ARTIST</span>
    </div>
    <div mat-menu-item (click)="addCriteria('title')">
      <mat-icon fontSet="fa" fontIcon="fa-microphone"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.TITLE</span>
    </div>
    <div mat-menu-item (click)="addCriteria('album')">
      <mat-icon fontSet="fa" fontIcon="fa-image"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.ALBUM</span>
    </div>
    <div mat-menu-item (click)="addCriteria('year')">
      <mat-icon fontSet="fa" fontIcon="fa-calendar-alt"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.YEAR</span>
    </div>
    <div mat-menu-item (click)="addCriteria('bpm')">
      <mat-icon fontSet="fa" fontIcon="fa-poll"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.BPM</span>
    </div>
    <div mat-menu-item (click)="addCriteria('playtime_seconds')">
      <mat-icon fontSet="fa" fontIcon="fa-clock"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.DURATION</span>
    </div>
    <div mat-menu-item (click)="addCriteria('upload_date')">
      <mat-icon fontSet="fa" fontIcon="fa-calendar-plus"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.UPLOAD_DATE</span>
    </div>
    <div mat-menu-item (click)="addCriteria('tags')">
      <mat-icon fontSet="fa" fontIcon="fa-tag"></mat-icon>
      <span translate>PLAYLIST.CRITERIA.TAG</span>
    </div>
  </mat-menu>
</rk-sidenav-action-wrapper>
